<template>
    <div>
        <component :is="this.$route.meta.layout || 'div'">
            <transition name="fade-in-up" mode="out-in">
                <router-view/>
            </transition>
        </component>
    </div>
</template>

<script>
export default {
    name: 'App',
};
</script>

<style src="./assets/css/bootstrap-reboot.css"></style>
<style src="./assets/css/bootstrap-grid.css"></style>
<style src="./assets/css/style.css"></style>
